import React from "react";
import Default from "../components/dashboard/defaultCompo/default";

export const layoutRoutes = [
  // {
  //   path: `/`,
  //   Component: <Default />,
  //   permission: "dashboard"
  // },
  {
    path: `/dashboard/default`,
    Component: <Default />,
    permission: "dashboard"
  }
];
